import React, { useState, useEffect } from "react";
import axios from "axios";
import "./AboutPage.css";
import IntroTemplate from "../../components/IntroTemplate/IntroTemplate";
import LearnAbout from "../../components/LearnAbout/LearnAbout";
import CompanyIntro from "../../components/CompanyIntro/CompanyIntro";
import SustainabilityRedirect from "../../components/SustainabilityRedirect/SustainabilityRedirect";
import RedirectToPage from "../../components/RedirectToPage/RedirectToPage";
import AllIndustries from "../../components/ProductList/AllIndustries";
import OurPresence from "../../components/ProjectsMap/OurPresence";
import FootprintStats from "../../components/FootprintStats/FootprintStats";
import { getStoredData } from "../../JsonFiles/fetchData";

const AboutPage = () => {
  // Fetch data from local storage or API
  const data = getStoredData()?.["4"] ?? {};
  
  // State to manage products data
  const [products, setProducts] = useState([]);

  // Fetch products on component mount
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          "https://shahbad-enterprises-backend.vercel.app/products"
        );
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, []);

  return (
    <div className="about-page-container">
      {/* Intro Section */}
      <IntroTemplate 
        logo={data.logo} 
        title={data.title} 
        image={data.image} 
      />

      {/* Learn About Section */}
      <LearnAbout 
        links={data.QuickLinks} 
        title={data.AboutTitle} 
        button={data.AboutButton} 
        Link={data.AboutRedirectLink} 
      />

      {/* Company Introduction Section */}
      <CompanyIntro 
        title={data.CompanyTitle} 
        details={data.CompanyDetails} 
        links={data.CompanyLink} 
      />

      {/* Sustainability Section */}
      <SustainabilityRedirect 
        title={data.SustainableTitle} 
        details={data.SustainableDetails} 
        ButtonText={data.SustainableButton} 
        Link={data.SustainableLink} 
        image={data.SustainableImage} 
      />

      {/* History Redirect Section */}
      <RedirectToPage 
        link={data.HistoryRedirectLink} 
        title={data.HistoryRedirectTitle} 
        image={data.HistoryRedirectImage} 
        details={data.HistoryRedirectDetails} 
        ButtonText={data.HistoryRedirectButton} 
      />

      {/* All Industries Section */}
      <AllIndustries 
        products={products} 
        title={data.Producttitle} 
        details={data.Productdetails} 
        link={data.Productlink} 
        linktext={data.Productlinktext} 
      />

      {/* Our Presence Section */}
      <OurPresence 
        data={data} 
      />

      {/* Footprint Statistics Section */}
      <FootprintStats 
        stats={data.stats} 
      />

      {/* General Redirect Section */}
      <RedirectToPage 
        link={data.RedirectLink} 
        title={data.RedirectTitle} 
        image={data.RedirectImage} 
        details={data.RedirectDetails} 
        ButtonText={data.RedirectButtonText} 
      />
    </div>
  );
};

export default AboutPage;
